var map = {
	"./capa_trofeus.jpg": 364,
	"./trofeus (1).jpg": 365,
	"./trofeus (2).jpg": 366,
	"./trofeus (3).jpg": 367,
	"./trofeus (4).jpg": 368,
	"./trofeus (5).jpg": 369,
	"./trofeus (6).jpg": 370,
	"./trofeus (7).jpg": 371
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus nonrecursive \.(jpg|jpeg|png|gif)$
// module id = 21
// module chunks = 0